import { makeInternalAPIRequest } from 'lib/http/ApiProvider'
import Response from 'lib/http/Response'

export const me = (): Promise<Response> => makeInternalAPIRequest('get', '/me')

export const checkNewUser = (): Promise<Response> =>
	makeInternalAPIRequest('get', '/auth')
